import searchResults from '../components/Search-Results'
import store from '../data/store'

export default {
  name: 'search',
  data () {
    return {
      searchTearm: ''
    }
  },
  components: {
    'search-results': searchResults
  },
  computed: {
    getSearchTearm () {
      return `Search for ${store.state.searchType}s`
    }
  },
  methods: {
    setSearchType (event){
      let currentVal = event.currentTarget.value
      store.dispatch('setSearchType', {
        val: currentVal
      })
    },
    search () {
      if(this.searchTearm !== ""){
        store.state.nextLink = 1;
        store.dispatch('search', {
          tearm: this.searchTearm,
          type: 'search'
        })
        this.searchTearm = ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mv/search.js